import { useMemo } from 'react';

import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import type { CommentShareChannel, PartialComment, PartialPetition, ShareConfig } from '../types';

import { useGetCommentShareText } from './text';
import { useGetCommentShareTrackingData } from './tracking';
import { useGetCommentShareUrl } from './url';

export function useCommentShareOptions(
	comment: PartialComment,
	petition: PartialPetition,
	config: ShareConfig,
): ShareActionsOptions<CommentShareChannel> {
	const getUrl = useGetCommentShareUrl(comment, petition);
	const getText = useGetCommentShareText(comment);
	const getTrackingData = useGetCommentShareTrackingData(comment, petition, config);

	return useMemo(
		() => ({
			trackingEventName: 'comment_share',
			getUrl,
			getText,
			getTrackingData,
		}),
		[getUrl, getText, getTrackingData],
	);
}
